export enum IdeaFieldTypes {
  boolean = 'boolean',
  date = 'date',
  dropdown = 'dropdown',
  group = 'group',
  number = 'number',
  multilineText = 'multilineText',
  multiselect = 'multiselect',
  text = 'text',
  user = 'user',
  url = 'url',
}

export enum DefaultFieldNames {
  Author = 'author',
  Category = 'category',
  Group = 'group',
  Owner = 'owner',
  Status = 'status',
  Tags = 'tags',
  Title = 'title',
  Type = 'type',
}

// helper type to map IdeaFieldTypes to their corresponding TypeScript types
export type FieldTypeMap = {
  [IdeaFieldTypes.boolean]: boolean;
  [IdeaFieldTypes.date]: Date;
  [IdeaFieldTypes.dropdown]: string;
  [IdeaFieldTypes.group]: string;
  [IdeaFieldTypes.number]: number;
  [IdeaFieldTypes.multilineText]: string;
  [IdeaFieldTypes.multiselect]: string[];
  [IdeaFieldTypes.text]: string;
  [IdeaFieldTypes.user]: string;
  [IdeaFieldTypes.url]: string;
};

export type DefaultFieldTypeMap = {
  [DefaultFieldNames.Author]: IdeaFieldTypes.user;
  [DefaultFieldNames.Category]: IdeaFieldTypes.text;
  [DefaultFieldNames.Group]: IdeaFieldTypes.group;
  [DefaultFieldNames.Owner]: IdeaFieldTypes.user;
  [DefaultFieldNames.Status]: IdeaFieldTypes.text;
  [DefaultFieldNames.Tags]: IdeaFieldTypes.multiselect;
  [DefaultFieldNames.Title]: IdeaFieldTypes.text;
  [DefaultFieldNames.Type]: IdeaFieldTypes.text;
};

export const CustomIdeaFieldTypesList = Object.values(IdeaFieldTypes).filter(
  (type) => type !== IdeaFieldTypes.group
);
